export default __webpack_public_path__ + "static/media/DNo.5-1.8d6c5be0.jpg";